import { useEffect, useMemo, useState } from "react";

/**
 * 프론트(클라이언트) 페이징 어댑터 훅.
 *
 * 전체 행 배열을 받아 현재 페이지 조각만 잘라준다. 반환 형태는 추후 서버 페이징
 * 훅(useServerPagination)으로 교체해도 동일하게 유지되도록 설계 — DataTable/Pagination은
 * 그대로 두고 이 훅만 바꾸면 된다.
 *
 * @param rows 전체(필터 적용된) 행 배열
 * @param pageSize 페이지당 개수 (기본 10)
 * @returns { pageItems, page, setPage, pageSize, totalCount }
 */
export function useClientPagination(rows, { pageSize = 10 } = {}) {
  const [page, setPage] = useState(1);
  const totalCount = rows.length;
  const pageCount = Math.max(1, Math.ceil(totalCount / pageSize));

  // 데이터가 줄어 현재 페이지가 범위를 벗어나면 마지막 페이지로 보정
  useEffect(() => {
    if (page > pageCount) {
      setPage(pageCount);
    }
  }, [page, pageCount]);

  const pageItems = useMemo(() => {
    const start = (page - 1) * pageSize;
    return rows.slice(start, start + pageSize);
  }, [rows, page, pageSize]);

  return { pageItems, page, setPage, pageSize, totalCount };
}

export default useClientPagination;
